import { Archive, Edit, Eye, Trash, Unarchive } from 'seagull/icons';
import { eligibilityTooltipTitle } from './ClientsPage.utils';
export const clientInlineActions = (param)=>{
    let { client, texts, onViewClient } = param;
    return [
        {
            icon: Eye,
            label: texts.actions.view(),
            heapId: 'client-view-btn',
            onClick: ()=>onViewClient(client),
            bi: {
                name: 'clients_view'
            }
        }
    ];
};
export const clientMenuActions = (param)=>{
    let { client, texts, eligibilityTooltipsTexts, onEditClient, onArchiveClient, onRestoreClient, onDeleteClient } = param;
    const canArchive = client.archiveEligibility.type !== 'notEligible';
    const canDelete = client.deleteEligibility.type !== 'notEligible';
    // WHY: a client shared with other vendors is read-only here; only Delete stays governed by its own eligibility.
    const sharedTooltip = client.isMultiVendorCustomer ? texts.multiVendorClientTooltip() : undefined;
    return [
        {
            icon: Edit,
            label: texts.actions.edit(),
            onClick: ()=>onEditClient(client),
            bi: {
                name: 'client_edit'
            },
            disabled: client.isMultiVendorCustomer,
            tooltip: sharedTooltip
        },
        ...client.status === 'active' ? [
            {
                icon: Archive,
                label: texts.actions.archive(),
                onClick: ()=>onArchiveClient(client),
                bi: {
                    name: 'client_archive'
                },
                disabled: !canArchive || client.isSample || client.isMultiVendorCustomer,
                tooltip: sharedTooltip !== null && sharedTooltip !== void 0 ? sharedTooltip : eligibilityTooltipTitle(client.archiveEligibility, 'archive', eligibilityTooltipsTexts)
            }
        ] : [],
        ...client.status === 'archived' ? [
            {
                icon: Unarchive,
                label: texts.actions.unarchive(),
                onClick: ()=>onRestoreClient(client),
                bi: {
                    name: 'client_restore'
                },
                disabled: client.isMultiVendorCustomer,
                tooltip: sharedTooltip
            }
        ] : [],
        {
            icon: Trash,
            label: texts.actions.delete(),
            onClick: ()=>onDeleteClient(client),
            bi: {
                name: 'client_delete'
            },
            destructive: true,
            disabled: !canDelete || client.isSample,
            tooltip: eligibilityTooltipTitle(client.deleteEligibility, 'delete', eligibilityTooltipsTexts)
        }
    ];
};
